export default {
  title: 'SEO',
  subtitle:
    'Personalize o título e a descrição que aparecem nos resultados do Google e nas pré-visualizações sociais. Deixe vazio para usar os valores predefinidos.',
  fields: {
    title: {
      label: 'Título da página',
      placeholder: 'ex.: Forza Napoli — pizza napolitana autêntica em Munique',
      help: 'Apresentado como título nos resultados do Google e nos separadores do browser. Até 255 caracteres; recomenda-se 50–60 para melhor pré-visualização.',
    },
    description: {
      label: 'Meta descrição',
      placeholder: 'Resumo breve do seu restaurante que aparecerá sob o título nos resultados de pesquisa.',
      help: 'Até 500 caracteres; o Google exibe tipicamente 150–160. Destaque o que torna o seu restaurante único.',
    },
  },
  buttons: {
    save: 'Guardar',
  },
  toasts: {
    saved: 'Definições de SEO guardadas',
    failed: 'Falha ao guardar as definições de SEO',
  },
};
